<script>
  export let message;
</script>

{#if message}
  <p class="text-danger">{message}</p>
{/if}
